// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminUserManagement-space1-vepwL {
	margin-bottom: 6px !important;
}

.AdminUserManagement-space2-HfDXd {
	margin-bottom: 12px !important;
}

.AdminUserManagement-space3-uMtkS {
	margin-bottom: 18px !important;
}

.AdminUserManagement-space4-n2aUo {
	margin-bottom: 24px !important;
}

.AdminUserManagement-space5-uJytu {
	margin-bottom: 30px !important;
}

.AdminUserManagement-space6-mYwqS {
	margin-bottom: 36px !important;
}

.AdminUserManagement-space7-BIDKI {
	margin-bottom: 42px !important;
}

.AdminUserManagement-space8-NFllt {
	margin-bottom: 48px !important;
}

.AdminUserManagement-spaceTop1-DGQT5 {
	margin-top: 6px !important;
}

.AdminUserManagement-spaceTop2-mEzeG {
	margin-top: 12px !important;
}

.AdminUserManagement-spaceTop3-XVHba {
	margin-top: 18px !important;
}

.AdminUserManagement-spaceTop4-G_inQ {
	margin-top: 24px !important;
}

.AdminUserManagement-spaceTop5-Sdnal {
	margin-top: 30px !important;
}

.AdminUserManagement-spaceTop6-x47A9 {
	margin-top: 36px !important;
}

.AdminUserManagement-spaceTop7-duZtI {
	margin-top: 42px !important;
}

.AdminUserManagement-spaceTop8-m7k2y {
	margin-top: 48px !important;
}

.AdminUserManagement-noMargin-ly1st {
	margin: 0px !important;
}

.AdminUserManagement-padding1-rRNf4 {
	padding-bottom: 6px !important;
}

.AdminUserManagement-padding2-lJ_0d {
	padding-bottom: 12px !important;
}

.AdminUserManagement-padding3-N5pa1 {
	padding-bottom: 18px !important;
}

.AdminUserManagement-padding4-cIMvk {
	padding-bottom: 24px !important;
}

.AdminUserManagement-padding5-YQlfN {
	padding-bottom: 30px !important;
}

.AdminUserManagement-padding6-uykWZ {
	padding-bottom: 36px !important;
}

.AdminUserManagement-padding7-BM7u2 {
	padding-bottom: 42px !important;
}

.AdminUserManagement-paddingTop1-HyE1D {
	padding-top: 6px !important;
}

.AdminUserManagement-paddingTop2-B4UtC {
	padding-top: 12px !important;
}

.AdminUserManagement-paddingTop3-hB7jL {
	padding-top: 18px !important;
}

.AdminUserManagement-paddingTop4-ugJJc {
	padding-top: 24px !important;
}

.AdminUserManagement-paddingTop5-cqOMB {
	padding-top: 30px !important;
}

.AdminUserManagement-paddingTop6-E5w1u {
	padding-top: 36px !important;
}

.AdminUserManagement-paddingTop7-UQKGn {
	padding-top: 42px !important;
}

.AdminUserManagement-noPadding-cOqwr {
	padding: 0px !important;
}

.AdminUserManagement-spaceMarginBottom0-P3_Kz {
	margin-bottom: 0;
}

.AdminUserManagement-textBold-qTsBp {
	font-weight: 500 !important;
}

.AdminUserManagement-textBolder-HvwdF {
	font-weight: 700 !important;
}

.AdminUserManagement-textNormal-kWi3a {
	font-weight: normal !important;
}

/*New Design Text Colors */

.AdminUserManagement-textDarkBlue-uBREu {
	color: rgb(20, 39, 94) !important;
}

.AdminUserManagement-textLightBlue-SAw6L {
	color: rgb(57, 87, 106) !important;
}

.AdminUserManagement-textLightSandleGreen-cAgVC {
	color: rgb(76, 86, 41) !important;
}

.AdminUserManagement-textLightBrown-weJSz {
	color: rgb(115, 79, 33) !important;
}

.AdminUserManagement-textMediumMaroon-Ys5ZB {
	color: rgb(87, 37, 51) !important;
}

.AdminUserManagement-textBrown-qQozJ {
	color: rgb(160, 47, 24) !important;
}

.AdminUserManagement-textMaroon-I0CcL {
	color: rgb(155, 49, 67) !important;
}

.AdminUserManagement-textDarkBrown-ZM7D2 {
	color: rgb(83, 18, 16) !important;
}

.AdminUserManagement-textMediumBrown-Qd19I {
	color: rgb(142, 28, 10) !important;
}

.AdminUserManagement-textSkyBlue-Jqr79 {
	color: rgb(37, 117, 141) !important;
}

.AdminUserManagement-textGray-qX2oA {
	color: rgb(77, 65, 51) !important;
}

.AdminUserManagement-errorMessage-NQCsK {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.AdminUserManagement-userText-ETOSv {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.AdminUserManagement-panelHeader-PWkFN {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.AdminUserManagement-exportSection-Ksscv {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.AdminUserManagement-exportSectionGridSub-iQPvr {
	grid-template-columns: 50% 49% !important;
}

.AdminUserManagement-exportText-WQoZw {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.AdminUserManagement-exportLinkImg-sgwe4 {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.AdminUserManagement-exportImg-Oorff {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.AdminUserManagement-linkBtn-bIifB {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.AdminUserManagement-table-ZFskH {
	display: table;
}

.AdminUserManagement-tableRow-LliAI {
	display: table-row;
}

.AdminUserManagement-tableCell-OJr5R {
	display: table-cell;
	float: none;
}

.AdminUserManagement-formGroup-f5j8g {
	margin-bottom: 6px;
}

.AdminUserManagement-marginTop0-yP41H {
	margin-top: 0;
}

.AdminUserManagement-marginBottom20-NHnw_ {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.AdminUserManagement-bannerImageBg-Ai7GH {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.AdminUserManagement-bannerDelete-CB9F9 {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.AdminUserManagement-exportLink-luVwH {
	padding-top: 10px;
	padding-right: 10px;
}

.AdminUserManagement-seachContent-DGmWd {
	padding-left: 0px;
	margin-bottom: 5px;
}

.AdminUserManagement-marginBottom9-FIT3t {
	margin-bottom: 9px;
}

.AdminUserManagement-spaceTop52-IBCWC {
	margin-top: 52px;
}

.AdminUserManagement-profileViewInner-loSub {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.AdminUserManagement-profileViewMain-o3C6R {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.AdminUserManagement-profileViewlabel-uVHPb {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.AdminUserManagement-profileViewMainContent-iBBZD {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.AdminUserManagement-reviewsFormStar-ZRrHp {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.AdminUserManagement-reviewsFormStar-ZRrHp svg {
	cursor: pointer;
}

.AdminUserManagement-addLanguageText-dW1Nx {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.AdminUserManagement-exportSection-Ksscv {
		grid-template-columns: 100%;
	}

	.AdminUserManagement-spaceTop52-IBCWC {
		margin-top: 18px;
	}

	.AdminUserManagement-exportText-WQoZw {
		float: none;
		margin-top: 12px;
	}

	.AdminUserManagement-exportSectionGridSub-iQPvr {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.AdminUserManagement-profileViewlabel-uVHPb {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.AdminUserManagement-profileViewMainContent-iBBZD {
		width: 100%;
		text-align: center;
	}

	.AdminUserManagement-panelHeader-PWkFN {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `AdminUserManagement-space1-vepwL`,
	"space2": `AdminUserManagement-space2-HfDXd`,
	"space3": `AdminUserManagement-space3-uMtkS`,
	"space4": `AdminUserManagement-space4-n2aUo`,
	"space5": `AdminUserManagement-space5-uJytu`,
	"space6": `AdminUserManagement-space6-mYwqS`,
	"space7": `AdminUserManagement-space7-BIDKI`,
	"space8": `AdminUserManagement-space8-NFllt`,
	"spaceTop1": `AdminUserManagement-spaceTop1-DGQT5`,
	"spaceTop2": `AdminUserManagement-spaceTop2-mEzeG`,
	"spaceTop3": `AdminUserManagement-spaceTop3-XVHba`,
	"spaceTop4": `AdminUserManagement-spaceTop4-G_inQ`,
	"spaceTop5": `AdminUserManagement-spaceTop5-Sdnal`,
	"spaceTop6": `AdminUserManagement-spaceTop6-x47A9`,
	"spaceTop7": `AdminUserManagement-spaceTop7-duZtI`,
	"spaceTop8": `AdminUserManagement-spaceTop8-m7k2y`,
	"noMargin": `AdminUserManagement-noMargin-ly1st`,
	"padding1": `AdminUserManagement-padding1-rRNf4`,
	"padding2": `AdminUserManagement-padding2-lJ_0d`,
	"padding3": `AdminUserManagement-padding3-N5pa1`,
	"padding4": `AdminUserManagement-padding4-cIMvk`,
	"padding5": `AdminUserManagement-padding5-YQlfN`,
	"padding6": `AdminUserManagement-padding6-uykWZ`,
	"padding7": `AdminUserManagement-padding7-BM7u2`,
	"paddingTop1": `AdminUserManagement-paddingTop1-HyE1D`,
	"paddingTop2": `AdminUserManagement-paddingTop2-B4UtC`,
	"paddingTop3": `AdminUserManagement-paddingTop3-hB7jL`,
	"paddingTop4": `AdminUserManagement-paddingTop4-ugJJc`,
	"paddingTop5": `AdminUserManagement-paddingTop5-cqOMB`,
	"paddingTop6": `AdminUserManagement-paddingTop6-E5w1u`,
	"paddingTop7": `AdminUserManagement-paddingTop7-UQKGn`,
	"noPadding": `AdminUserManagement-noPadding-cOqwr`,
	"spaceMarginBottom0": `AdminUserManagement-spaceMarginBottom0-P3_Kz`,
	"textBold": `AdminUserManagement-textBold-qTsBp`,
	"textBolder": `AdminUserManagement-textBolder-HvwdF`,
	"textNormal": `AdminUserManagement-textNormal-kWi3a`,
	"textDarkBlue": `AdminUserManagement-textDarkBlue-uBREu`,
	"textLightBlue": `AdminUserManagement-textLightBlue-SAw6L`,
	"textLightSandleGreen": `AdminUserManagement-textLightSandleGreen-cAgVC`,
	"textLightBrown": `AdminUserManagement-textLightBrown-weJSz`,
	"textMediumMaroon": `AdminUserManagement-textMediumMaroon-Ys5ZB`,
	"textBrown": `AdminUserManagement-textBrown-qQozJ`,
	"textMaroon": `AdminUserManagement-textMaroon-I0CcL`,
	"textDarkBrown": `AdminUserManagement-textDarkBrown-ZM7D2`,
	"textMediumBrown": `AdminUserManagement-textMediumBrown-Qd19I`,
	"textSkyBlue": `AdminUserManagement-textSkyBlue-Jqr79`,
	"textGray": `AdminUserManagement-textGray-qX2oA`,
	"errorMessage": `AdminUserManagement-errorMessage-NQCsK`,
	"userText": `AdminUserManagement-userText-ETOSv`,
	"panelHeader": `AdminUserManagement-panelHeader-PWkFN`,
	"exportSection": `AdminUserManagement-exportSection-Ksscv`,
	"exportSectionGridSub": `AdminUserManagement-exportSectionGridSub-iQPvr`,
	"exportText": `AdminUserManagement-exportText-WQoZw`,
	"exportLinkImg": `AdminUserManagement-exportLinkImg-sgwe4`,
	"exportImg": `AdminUserManagement-exportImg-Oorff`,
	"linkBtn": `AdminUserManagement-linkBtn-bIifB`,
	"table": `AdminUserManagement-table-ZFskH`,
	"tableRow": `AdminUserManagement-tableRow-LliAI`,
	"tableCell": `AdminUserManagement-tableCell-OJr5R`,
	"formGroup": `AdminUserManagement-formGroup-f5j8g`,
	"marginTop0": `AdminUserManagement-marginTop0-yP41H`,
	"marginBottom20": `AdminUserManagement-marginBottom20-NHnw_`,
	"bannerImageBg": `AdminUserManagement-bannerImageBg-Ai7GH`,
	"bannerDelete": `AdminUserManagement-bannerDelete-CB9F9`,
	"exportLink": `AdminUserManagement-exportLink-luVwH`,
	"seachContent": `AdminUserManagement-seachContent-DGmWd`,
	"marginBottom9": `AdminUserManagement-marginBottom9-FIT3t`,
	"spaceTop52": `AdminUserManagement-spaceTop52-IBCWC`,
	"profileViewInner": `AdminUserManagement-profileViewInner-loSub`,
	"profileViewMain": `AdminUserManagement-profileViewMain-o3C6R`,
	"profileViewlabel": `AdminUserManagement-profileViewlabel-uVHPb`,
	"profileViewMainContent": `AdminUserManagement-profileViewMainContent-iBBZD`,
	"reviewsFormStar": `AdminUserManagement-reviewsFormStar-ZRrHp`,
	"addLanguageText": `AdminUserManagement-addLanguageText-dW1Nx`
};
module.exports = ___CSS_LOADER_EXPORT___;
